import {datesHelper} from "./dates.helper";

export const customerHelper = {
  validateField,
  checkCurrent,
  setCookie,
  _validateDniNie,
  _validateEmail,
  toForm
}

function _validateEmail(email){
  if (email.length === 0) return false
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function _validateDniNie(doc){
  const re = /(([x-z]|[X-Z]{1})([-]?)(\d{7})([-]?)([a-z]|[A-Z]{1}))|((\d{8})([-]?)([a-z]|[A-Z]{1}))|(([a-b]|[A-B]{1})([-]?)(\d{8}))/g
  return re.test(doc)
}

function validateField(value, validators){

  let errors = []
  let response = {
    'result': true
  }
  validators.forEach(v => {
    let _key = Object.keys(v)[0]

    switch (_key) {
      case 'lon':
        if(value.length < parseInt(v[_key])){
          response.result = false
          errors.push('lon')
        }
        break
      case 'mail':
        if(!_validateEmail(value)){
          response.result = false
          errors.push('mail')
        }
        break
      case 'dni':
        if(value.length < parseInt(v[_key]) && !_validateDniNie(value)){
          response.result = false
          errors.push('dni')
        }
        break
      case 'edad':
        if(!datesHelper.isAdult(value)) {
          response.result = false
          errors.push('edad')
        }
        break
    }
  })
  if(!response.result) response['errors'] = errors


  return response
}

function checkCurrent(cname='user-token') {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  let rdo = '';
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      rdo = c.substring(name.length, c.length);
    }
  }
  return rdo;
}

function setCookie(token, eliminar=false){
  let now = null
  if(!eliminar) {
    now = new Date()
    let time = now.getTime()
    time += 3600 * 1000
    now.setTime(time)
  }else{
    now = new Date(1970,1,1,0,0,0)
  }

  document.cookie =
    'user-token=' + token +
    '; expires=' + now.toUTCString() +
    '; path=/';
}

function toForm(user){
  console.log(user)
  //delete user.id
  //delete user.username
  user['name'] = user.nombre
  delete user.nombre

  user['surname'] = user.apellidos
  delete user.apellidos

  user['confirmar'] = user.email

  user['phone'] = user.telefono
  delete user.telefono

  user['street'] = user.direccion
  delete user.direccion

  user['postcode'] = user.cp
  delete user.cp

  user['state'] = user.localidad
  delete user.localidad

  user['city'] = user.poblacion
  delete user.poblacion

  user['country'] = user.pais || "España"
  delete user.pais

  user['birthday'] = user.fechnac
  delete user.fechnac

  user['club'] = user.clubs
  delete user.clubs

  return user

}

export const countries = [
  "Afganistán",
  "Albania",
  "Alemania",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antártida",
  "Antigua y Barbuda",
  "Antillas Holandesas",
  "Arabia Saudí",
  "Argelia",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaiyán",
  "Bahamas",
  "Bahrein",
  "Bangladesh",
  "Barbados",
  "Bélgica",
  "Belice",
  "Benin",
  "Bermudas",
  "Bielorrusia",
  "Birmania",
  "Bolivia",
  "Bosnia y Herzegovina",
  "Botswana",
  "Brasil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Bután",
  "Cabo Verde",
  "Camboya",
  "Camerún",
  "Canadá",
  "Chad",
  "Chile",
  "China",
  "Chipre",
  "Ciudad del Vaticano (Santa Sede)",
  "Colombia",
  "Comores",
  "Congo",
  "Congo, República Democrática del",
  "Corea",
  "Corea del Norte",
  "Costa de Marfíl",
  "Costa Rica",
  "Croacia (Hrvatska)",
  "Cuba",
  "Dinamarca",
  "Djibouti",
  "Dominica",
  "Ecuador",
  "Egipto",
  "El Salvador",
  "Emiratos Árabes Unidos",
  "Eritrea",
  "Eslovenia",
  "España",
  "Estados Unidos",
  "Estonia",
  "Etiopía",
  "Fiji",
  "Filipinas",
  "Finlandia",
  "Francia",
  "Gabón",
  "Gambia",
  "Georgia",
  "Ghana",
  "Gibraltar",
  "Granada",
  "Grecia",
  "Groenlandia",
  "Guadalupe",
  "Guam",
  "Guatemala",
  "Guayana",
  "Guayana Francesa",
  "Guinea",
  "Guinea Ecuatorial",
  "Guinea-Bissau",
  "Haití",
  "Honduras",
  "Hungría",
  "India",
  "Indonesia",
  "Irak",
  "Irán",
  "Irlanda",
  "Isla Bouvet",
  "Isla de Christmas",
  "Islandia",
  "Islas Caimán",
  "Islas Cook",
  "Islas de Cocos o Keeling",
  "Islas Faroe",
  "Islas Heard y McDonald",
  "Islas Malvinas",
  "Islas Marianas del Norte",
  "Islas Marshall",
  "Islas menores de Estados Unidos",
  "Islas Palau",
  "Islas Salomón",
  "Islas Svalbard y Jan Mayen",
  "Islas Tokelau",
  "Islas Turks y Caicos",
  "Islas Vírgenes (EEUU)",
  "Islas Vírgenes (Reino Unido)",
  "Islas Wallis y Futuna",
  "Israel",
  "Italia",
  "Jamaica",
  "Japón",
  "Jordania",
  "Kazajistán",
  "Kenia",
  "Kirguizistán",
  "Kiribati",
  "Kuwait",
  "Laos",
  "Lesotho",
  "Letonia",
  "Líbano",
  "Liberia",
  "Libia",
  "Liechtenstein",
  "Lituania",
  "Luxemburgo",
  "Macedonia, Ex-República Yugoslava de",
  "Madagascar",
  "Malasia",
  "Malawi",
  "Maldivas",
  "Malí",
  "Malta",
  "Marruecos",
  "Martinica",
  "Mauricio",
  "Mauritania",
  "Mayotte",
  "México",
  "Micronesia",
  "Moldavia",
  "Mónaco",
  "Mongolia",
  "Montserrat",
  "Mozambique",
  "Namibia",
  "Nauru",
  "Nepal",
  "Nicaragua",
  "Níger",
  "Nigeria",
  "Niue",
  "Norfolk",
  "Noruega",
  "Nueva Caledonia",
  "Nueva Zelanda",
  "Omán",
  "Países Bajos",
  "Panamá",
  "Papúa Nueva Guinea",
  "Paquistán",
  "Paraguay",
  "Perú",
  "Pitcairn",
  "Polinesia Francesa",
  "Polonia",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reino Unido",
  "República Centroafricana",
  "República Checa",
  "República de Sudáfrica",
  "República Dominicana",
  "República Eslovaca",
  "Reunión",
  "Ruanda",
  "Rumania",
  "Rusia",
  "Sahara Occidental",
  "Saint Kitts y Nevis",
  "Samoa",
  "Samoa Americana",
  "San Marino",
  "San Vicente y Granadinas",
  "Santa Helena",
  "Santa Lucía",
  "Santo Tomé y Príncipe",
  "Senegal",
  "Seychelles",
  "Sierra Leona",
  "Singapur",
  "Siria",
  "Somalia",
  "Sri Lanka",
  "St Pierre y Miquelon",
  "Suazilandia",
  "Sudán",
  "Suecia",
  "Suiza",
  "Surinam",
  "Tailandia",
  "Taiwán",
  "Tanzania",
  "Tayikistán",
  "Territorios franceses del Sur",
  "Timor Oriental",
  "Togo",
  "Tonga",
  "Trinidad y Tobago",
  "Túnez",
  "Turkmenistán",
  "Turquía",
  "Tuvalu",
  "Ucrania",
  "Uganda",
  "Uruguay",
  "Uzbekistán",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Yugoslavia",
  "Zambia",
  "Zimbabue"]

export const provinces = [
  'Albacete',
  'Alicante/Alacant',
  'Almería',
  'Araba/Álava',
  'Asturias',
  'Ávila',
  'Badajoz',
  'Balears, Illes',
  'Barcelona',
  'Bizkaia',
  'Burgos',
  'Cáceres',
  'Cádiz',
  'Cantabria',
  'Castellón/Castelló',
  'Ceuta',
  'Ciudad Real',
  'Córdoba',
  'Coruña, A',
  'Cuenca',
  'Gipuzkoa',
  'Gerona',
  'Granada',
  'Guadalajara',
  'Huelva',
  'Huesca',
  'Jaén',
  'León',
  'Lérida',
  'Lugo',
  'Madrid',
  'Málaga',
  'Melilla',
  'Murcia',
  'Navarra',
  'Ourense',
  'Palencia',
  'Palmas, Las',
  'Pontevedra',
  'Rioja, La',
  'Salamanca',
  'Santa Cruz de Tenerife',
  'Segovia',
  'Sevilla',
  'Soria',
  'Tarragona',
  'Teruel',
  'Toledo',
  'Valencia/València',
  'Valladolid',
  'Zamora',
  'Zaragoza'
]
export const prefixes = {
  'Alemania': '49',
  'Francia': '33',
  'España': '34',
  'Reino Unido': '44'
}



// WEBPACK FOOTER //
// ./src/_helpers/customer.helper.js